import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ModalComp, Add } from "./";
import { useTranslation } from "react-i18next";
import { FiHome, FiPlus, FiCamera, FiX, FiCheck } from "react-icons/fi";

const ShortcutModal = () => {
  const { t } = useTranslation();
  const [showRoom, setShowRoom] = useState(false);
  const dashboardDetail = useSelector((state) => state.dashboardDetails);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [zoneName, setZoneName] = useState("");
  const [openAddModal, setOpenAddModal] = useState(false);
  const toggleAdd = () => setOpenAddModal(!openAddModal);

  return (
    <>
      <ModalComp modal={openAddModal} toggle={toggleAdd} component={<Add />} />
      
      {/* Shortcut Bar */}
      <div className="shortcut-modal-footer">
        <div className="shortcut-modal-buttons">
          <div className="shortcut-modal-icon">
            <i className="icon-device"></i>
          </div>
          <div className="shortcut-modal-icon">
            <FiCamera size={20} />
          </div>
          <div className="shortcut-modal-selector" onClick={() => setShowRoom(!showRoom)}>
            <FiHome size={16} />
            <span>
              {zoneName
                ? zoneName
                : dashboardZones && dashboardZones[0]?.zone_caption}
            </span>
            <i className={`icon-down-open-big ${showRoom ? "rotate" : ""}`}></i>
          </div>
        </div>
      </div>

      {/* Zone Modal - Bottom Sheet Style */}
      {showRoom && (
        <div className="bottom-sheet-overlay" onClick={() => setShowRoom(false)}>
          <div className="bottom-sheet-container" onClick={(e) => e.stopPropagation()}>
            <div className="bottom-sheet-header">
              <h3 className="bottom-sheet-title">{t("انتخاب اتاق")}</h3>
              <button className="bottom-sheet-close" onClick={() => setShowRoom(false)}>
                <FiX size={18} />
              </button>
            </div>
            
            <div className="bottom-sheet-list">
              {dashboardZones?.map((zone, index) => (
                <div
                  key={index}
                  className={`bottom-sheet-item ${zoneName === zone.zone_caption ? "active" : ""}`}
                  onClick={() => setZoneName(zone.zone_caption)}
                >
                  <div className="bottom-sheet-item-icon">
                    <FiHome size={16} />
                  </div>
                  <span className="bottom-sheet-item-name">{zone.zone_caption}</span>
                  {zoneName === zone.zone_caption && <FiCheck size={14} />}
                </div>
              ))}
            </div>
            
            <div className="bottom-sheet-footer">
              <button className="bottom-sheet-add-btn" onClick={toggleAdd}>
                <FiPlus size={16} />
                <span>{t("اتاق جدید")}</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShortcutModal;